import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Requirements from './components/Requirements';
import Levels from './components/Levels';
import ShareGift from './components/ShareGift';
import ShareSection from './components/ShareSection';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Profile from './components/Profile';
import DownloadApp from './components/DownloadApp'; // <-- IMPORT NEW COMPONENT
import './App.css';

// Komponen utama untuk halaman home
const HomePage = ({ theme, toggleTheme, scrollToSection }) => (
  <>
    <Navbar scrollToSection={scrollToSection} toggleTheme={toggleTheme} theme={theme} />
    <Hero scrollToSection={scrollToSection} />
    <Requirements />
    <Levels />
    <ShareGift />
    <ShareSection />
    <DownloadApp /> {/* <-- ADD DOWNLOAD APP COMPONENT HERE */}
    <Contact />
    <Footer />
    
    {/* Theme Toggle Button - positioned fixed */}
    <button 
      className="theme-toggle-fixed"
      onClick={toggleTheme}
      aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}
    >
      <i className={theme === 'dark' ? 'fas fa-sun' : 'fas fa-moon'}></i>
    </button>
    
    {/* Floating WhatsApp Button */}
    <a 
      href="https://wa.me/6285930139333?text=Halo,%20saya%20[Nama%20Kamu].%20Saya%20ingin%20bergabung%20dengan%20WM%20MANAGEMENT%20karena%20saya%20tertarik%20dengan%20program%20ini.%20Saya%20siap%20mengikuti%20aturan%20dan%20kontribusi%20positif.%20Mohon%20info%20langkah%20selanjutnya.%20Terima%20kasih%20banyak." 
      className="floating-whatsapp" 
      target="_blank" 
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <i className="fab fa-whatsapp"></i>
      <span className="floating-text">Chat Now</span>
    </a>
  </>
);

function App() {
  const [theme, setTheme] = useState('dark');

  useEffect(() => {
    // Check for saved theme preference
    const savedTheme = localStorage.getItem('theme');
    const prefersDarkScheme = window.matchMedia('(prefers-color-scheme: dark)');
    
    if (savedTheme) {
      setTheme(savedTheme);
      document.documentElement.setAttribute('data-theme', savedTheme);
    } else if (prefersDarkScheme.matches) {
      setTheme('dark');
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      setTheme('light');
      document.documentElement.setAttribute('data-theme', 'light');
    }
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
    document.documentElement.setAttribute('data-theme', newTheme);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const helmetData = {
    title: "Open Recruitment HOST MOMOLIVE - WAN MANAGEMENT",
    description: "Pendaftaran host Momolive, Bigo Live, Nonolive, Migolive - Bergabung menjadi host dengan penghasilan menarik dan bonus 70% share gift!",
    keywords: "recruitment, host, momolive, bigolive, nonolive, migolive, livestreaming, agensi, indonesia, download aplikasi",
    url: "https://www.wan-management.web.id/",
    image: "https://www.wan-management.web.id//og-image.jpg"
  };

  const profileHelmetData = {
    title: "Profile Host - WAN MANAGEMENT",
    description: "Kenali tim host profesional WAN MANAGEMENT. Temukan host berpengalaman siap membantu Anda sukses di platform livestreaming.",
    keywords: "host profile, crown management host, professional host, livestreaming host, team profile",
    url: "https://www.wan-management.web.id//profile",
    image: "https://www.wan-management.web.id//og-image.jpg"
  };

  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Route untuk halaman utama */}
            <Route path="/" element={
              <>
                <Helmet>
                  <title>{helmetData.title}</title>
                  <meta name="description" content={helmetData.description} />
                  <meta name="keywords" content={helmetData.keywords} />
                  <meta property="og:title" content={helmetData.title} />
                  <meta property="og:description" content={helmetData.description} />
                  <meta property="og:image" content={helmetData.image} />
                  <meta property="og:url" content={helmetData.url} />
                  <meta name="twitter:title" content={helmetData.title} />
                  <meta name="twitter:description" content={helmetData.description} />
                  <meta name="twitter:image" content={helmetData.image} />
                  <link rel="canonical" href={helmetData.url} />
                </Helmet>
                <HomePage 
                  theme={theme}
                  toggleTheme={toggleTheme}
                  scrollToSection={scrollToSection}
                />
              </>
            } />
            
            {/* Route untuk halaman profile */}
            <Route path="/profile" element={
              <>
                <Helmet>
                  <title>{profileHelmetData.title}</title>
                  <meta name="description" content={profileHelmetData.description} />
                  <meta name="keywords" content={profileHelmetData.keywords} />
                  <meta property="og:title" content={profileHelmetData.title} />
                  <meta property="og:description" content={profileHelmetData.description} />
                  <meta property="og:image" content={profileHelmetData.image} />
                  <meta property="og:url" content={profileHelmetData.url} />
                  <meta name="twitter:title" content={profileHelmetData.title} />
                  <meta name="twitter:description" content={profileHelmetData.description} />
                  <meta name="twitter:image" content={profileHelmetData.image} />
                  <link rel="canonical" href={profileHelmetData.url} />
                </Helmet>
                <Profile />
              </>
            } />
          </Routes>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
